import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const BULK_RATE_OPTIONS = [
  { value: 1, label: '×1.0 — ปกติ' },
  { value: 1.5, label: '×1.5 — พิเศษ' },
  { value: 2, label: '×2.0 — วันหยุด' },
  { value: 3, label: '×3.0 — วันหยุดนักขัตฤกษ์' },
];

const OV = { position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const MO = { background: '#fff', borderRadius: 8, maxWidth: 400, width: 'calc(100% - 32px)', maxHeight: '90vh', overflowY: 'auto' };
const MH = { padding: '14px 20px', borderBottom: '1px solid #e5e7eb' };
const MB = { padding: '14px 20px' };
const MF = { padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 8 };
const IS = { width: '100%', boxSizing: 'border-box', padding: '6px 10px', borderRadius: 4, border: '1px solid #d1d5db', fontSize: '0.875rem', outline: 'none' };
const BP = { padding: '6px 16px', borderRadius: 4, border: 'none', backgroundColor: '#1976d2', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500 };
const BC = { padding: '6px 14px', borderRadius: 4, border: '1px solid #d1d5db', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: '0.875rem' };

const Row = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', fontSize: '0.75rem', color: '#666', marginBottom: 3, fontWeight: 500 }}>{label}</label>
    {children}
  </div>
);

const BulkDayDialog = React.memo(function BulkDayDialog({
  open, onClose, bulkDay, month, year, bulkEmpCount,
  bulkTab, setBulkTab, bulkCheckIn, setBulkCheckIn, bulkCheckOut, setBulkCheckOut,
  bulkH, bulkRate, setBulkRate, bulkSaving, saveBulkDay, saveBulkDayRate,
}) {
  if (!open) return null;
  return (
    <div style={OV} onClick={onClose}>
      <div style={MO} onClick={(e) => e.stopPropagation()}>
        <div style={MH}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
            <AddCircleOutlineIcon style={{ fontSize: 18, color: '#1976d2' }} />
            <span style={{ fontWeight: 600, fontSize: '1rem' }}>จัดการวันที่ {bulkDay}/{month + 1}/{year}</span>
          </div>
          <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>พนักงาน {bulkEmpCount} คน</div>
        </div>

        <div style={{ padding: '10px 20px 0', display: 'flex', gap: 0, borderBottom: '1px solid #e5e7eb' }}>
          {[{ v: 0, l: 'เพิ่มเวลา' }, { v: 1, l: 'แก้ Rate' }].map(({ v, l }) => (
            <button key={v} onClick={() => setBulkTab(v)} style={{
              padding: '6px 16px', border: 'none', cursor: 'pointer', fontSize: '0.8125rem',
              background: 'none', fontWeight: bulkTab === v ? 600 : 400,
              color: bulkTab === v ? '#1976d2' : '#6b7280',
              borderBottom: bulkTab === v ? '2px solid #1976d2' : '2px solid transparent',
            }}>{l}</button>
          ))}
        </div>

        <div style={MB}>
          {bulkTab === 0 ? (
            <>
              <div style={{ display: 'flex', gap: 10, marginBottom: 0 }}>
                <Row label="เวลาเข้างาน">
                  <input type="time" value={bulkCheckIn} style={IS} onChange={(e) => setBulkCheckIn(e.target.value)} />
                </Row>
                <Row label="เวลาออกงาน">
                  <input type="time" value={bulkCheckOut} style={IS} onChange={(e) => setBulkCheckOut(e.target.value)} />
                </Row>
              </div>
              {bulkH > 0 && <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: 10, marginTop: -4 }}>รวม {bulkH % 1 === 0 ? bulkH : bulkH.toFixed(1)} ชม.</div>}
              <Row label="อัตราค่าแรง">
                <select value={bulkRate} style={{ ...IS, cursor: 'pointer' }} onChange={(e) => setBulkRate(Number(e.target.value))}>
                  {BULK_RATE_OPTIONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </Row>
              {bulkH > 0 && (
                <div style={{ backgroundColor: '#e3f2fd', borderRadius: 4, padding: '8px 12px' }}>
                  <div style={{ color: '#1976d2', fontWeight: 600, fontSize: '0.875rem' }}>
                    เพิ่มให้เฉพาะคนที่ยังไม่มีเวลา: {bulkH % 1 === 0 ? bulkH : bulkH.toFixed(1)} ชม. × ×{bulkRate}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>คนที่มีเวลาอยู่แล้วจะถูกข้ามไป</div>
                </div>
              )}
            </>
          ) : (
            <>
              <Row label="อัตราค่าแรง">
                <select value={bulkRate} style={{ ...IS, cursor: 'pointer' }} onChange={(e) => setBulkRate(Number(e.target.value))}>
                  {BULK_RATE_OPTIONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </Row>
              <div style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a', borderRadius: 4, padding: '8px 12px' }}>
                <div style={{ color: '#b45309', fontWeight: 600, fontSize: '0.875rem' }}>แก้ Rate ให้ทุกคนที่มีชั่วโมงทำงานวันนี้</div>
                <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>คนที่ไม่มีการลงเวลาจะถูกข้ามไป</div>
              </div>
            </>
          )}
        </div>

        <div style={MF}>
          <button style={BC} onClick={onClose} disabled={bulkSaving}>ยกเลิก</button>
          {bulkTab === 0 ? (
            <button style={{ ...BP, opacity: bulkSaving || bulkH <= 0 ? 0.6 : 1 }} onClick={saveBulkDay} disabled={bulkSaving || bulkH <= 0}>
              {bulkSaving ? 'กำลังบันทึก...' : 'บันทึกเวลา'}
            </button>
          ) : (
            <button
              style={{ ...BP, backgroundColor: '#ed6c02', opacity: bulkSaving || bulkRate <= 1 ? 0.6 : 1 }}
              onClick={saveBulkDayRate} disabled={bulkSaving || bulkRate <= 1}
            >
              {bulkSaving ? 'กำลังบันทึก...' : `ตั้ง ×${bulkRate} ให้ทุกคน`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

export default BulkDayDialog;
